import { Button, Stack } from "@mui/material";
import { useDataImportChangesListActionsContext } from "./DataImportChangesListActionsContext";
import type { DataImportChangeRowModel } from "./dataImportChangesGridTypes";

interface Props {
  row: DataImportChangeRowModel;
}

const DataImportChangesListEditActionsCell = ({ row }: Props) => {
  const { onCancelEditing, onApplyChanges } = useDataImportChangesListActionsContext();

  const buttonWidth = "4rem";

  return (
    <Stack direction="row" spacing={0.5} sx={{ py: 1, width: "100%" }}>
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => onCancelEditing(row.id)}
        sx={{ width: buttonWidth, minWidth: buttonWidth }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={() => onApplyChanges(row.id)}
        sx={{ width: buttonWidth, minWidth: buttonWidth }}
      >
        Apply
      </Button>
    </Stack>
  );
};

export default DataImportChangesListEditActionsCell;
